(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-shop-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aiworld-shop-menu')) {
    class AiWorldShopMenu extends HTMLElement {
      connectedCallback() {
        this.tablist = this.querySelector('[role="tablist"]');
        if (!this.tablist) return;

        this.tabs = Array.from(this.tablist.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab));
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, tab));
        });
      }

      activateTab(activeTab) {
        this.tabs.forEach((tab) => {
          const selected = tab === activeTab;
          const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          tab.classList.toggle('aiworld-shop-menu__category--active', selected);
          if (panel) panel.hidden = !selected;
        });
      }

      onTabKeydown(event, currentTab) {
        const currentIndex = this.tabs.indexOf(currentTab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % this.tabs.length;
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = this.tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        const nextTab = this.tabs[nextIndex];
        nextTab.focus();
        this.activateTab(nextTab);
      }
    }

    customElements.define('aiworld-shop-menu', AiWorldShopMenu);
  }
  } catch(e) { console.error(e); }
})();

})();
